import React from 'react';
import classNames from 'classnames';
import { ACCESS_STATE_ICON } from '../../data';
import { DataRoomNodeAccessState } from 'models/Lead';
import ResolvePopup from 'components/ResolvePopup';

import './DisplayFilesByCategoryTrigger.styles.scss';

type DisplayFilesByCategoryTriggerProps = {
  className?: string;
  state: DataRoomNodeAccessState;
  count: number;
  popupContent?: React.ReactNode;
  onClick?: () => void;
};

const DisplayFilesByCategoryTrigger: React.FC<
  DisplayFilesByCategoryTriggerProps
> = (props) => {
  const { className, state, count, popupContent, onClick } = props;

  const classes = classNames(
    'display-files-by-category-trigger',
    state,
    className,
  );

  const Icon = ACCESS_STATE_ICON[state];

  const content = (
    <div className={classes}>
      <Icon />
      <span className="display-files-by-category-trigger__count">{count}</span>
    </div>
  );

  return (
    <div
      className="display-files-by-category-trigger__wrapper"
      onClick={(e) => {
        e.stopPropagation();

        onClick?.();
      }}
    >
      {popupContent ? (
        <ResolvePopup
          onHover
          popupContent={popupContent}
          portalClassName="display-files-by-category-trigger__hint-popup"
        >
          {content}
        </ResolvePopup>
      ) : (
        content
      )}
    </div>
  );
};

export default DisplayFilesByCategoryTrigger;
